var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopCategoryNegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    className: "printSVG",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape",
    fill: "#D4002D",
    cx: 14,
    cy: 14,
    r: 14
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 19.5,
    cy: 8.5,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 8.5,
    cy: 8.5,
    r: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,25 C14.3213493,25 17,22.306948 17,19 C17,15.693052 14.3213493,13 11,13 L11,14.0322581 C13.7035752,14.0322581 15.9090909,16.2496314 15.9090909,19 C15.9090909,21.7503686 13.7035752,23.9677419 11,23.9677419 L11,25 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(14.000000, 19.000000) rotate(-90.000000) translate(-14.000000, -19.000000) "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCategoryNegative);
export default __webpack_public_path__ + "static/media/top-category-negative.97cd9136165ef66fae4a29a0a1bc0b99.svg";
export { ForwardRef as ReactComponent };